namespace JupitersChoice {
    export class FeatureTransitionCmd {

        @inject('ComponentManager') _componentManager: Sapphire.ComponentManager;
        @inject('EventManager') _eventManager: Sapphire.EventManager;
        @inject('LayerManager') _layerManager: Sapphire.LayerManager;
        @inject('OrientationModel') _orientationModel: Sapphire.OrientationModel;
        @inject('StateModel') _stateModel: Sapphire.StateModel;
        @inject('AudioModel') _audioModel: AudioModel;
        @inject('SoundManager') _soundManager: Sapphire.SoundManager;

        execute(): void {
            const baseGameLayer = this._layerManager.getLayerById('BaseGame');
            const reels = this._layerManager.getLayerById('Reels');
            //const reels = this._componentManager.get('Reels');
            const baseGameJupiter = this._componentManager.get('JupiterBaseGame');

            var originalJupiterX: number = baseGameJupiter.x;
            var originalJupiterY: number = baseGameJupiter.y;
            var JupiterOriginalScale: any = {x:baseGameJupiter.scale.x,y:baseGameJupiter.scale.y};

            this._componentManager.hideComponents(['SpinButton', 'StopAutoplayButton', 'AutoplaySpinRemainingText']);

            baseGameJupiter.changeAnimation('transition_intro');
            this._audioModel.switchToFreeSpins();
            var wobbleTimeLine = new TimelineMax({
                paused: true,
                repeat:2
            });
            wobbleTimeLine.add(TweenMax.to(baseGameJupiter,1,{
                x:"+=50",
                ease: Quad.easeOut
            }));
            wobbleTimeLine.add(TweenMax.to(baseGameJupiter,1,{
                x:"-=100",
                ease: Quad.easeInOut
            }));
            wobbleTimeLine.add(TweenMax.to(baseGameJupiter,1,{
                x:"+=50",
                ease: Quad.easeIn
            }));

            TweenMax.delayedCall(0.5, () => {
                this._soundManager.play('battle_cry_04');
            });

            var deltaX: number = this._orientationModel.isLandscape ? 600 : 350;

            TweenMax.delayedCall(1, () => {
                baseGameJupiter.changeAnimation('transition_loop', false, true);

                TweenMax.delayedCall(1, () => {
                    TweenMax.to(baseGameJupiter.scale,2,{
                        x:0.5,
                        y:0.5,
                        ease: Quad.easeIn
                    });

                    TweenMax.to(baseGameJupiter,2,{
                        x:"+="+(deltaX + (baseGameJupiter.width/2)),
                        y:"+="+(baseGameJupiter.height/4),
                        ease: Quad.easeIn,
                        onComplete: () => {
                            wobbleTimeLine.play();
                        }
                    });
                });
            });

            TweenMax.delayedCall(2.3, () => {
                this._componentManager.get('BaseGameSky').changeAnimation('transition_loop');
                this._soundManager.play('lightning_01');
            });

            TweenMax.delayedCall(4.5, () => {
                TweenMax.to(
                    baseGameJupiter,
                    1,
                    {
                        y: -3000,
                        ease:Quad.easeOut
                    }
                )
            });

            var transitionTimeline = new TimelineMax({
                paused: true,
                onComplete: () => {
                    TweenMax.delayedCall(3, () => {
                        this._eventManager.publish('onFeatureTransitionComplete');

                        this._layerManager.setVisibility('LightningFlash', true);
                        this._componentManager.get('SkyLightningFlash').changeAnimation('transition_outro', false);
                        this._soundManager.play('lightning_01',null,AudioConstants.MEGAHIT_LIGHTNING_VOLUME);
                        TweenMax.delayedCall(0.3,() => {
                            this._componentManager.get('WipeFlare').play(
                            () => {
                                this._componentManager.get('SkyLightningFlash').hide();
                                //this._layerManager.setVisibility('BaseGame', false);
                                TweenMax.killTweensOf(baseGameJupiter);
                                baseGameJupiter.pause();
                                this._layerManager.setVisibility('BaseGameJupiter', false);
                                baseGameJupiter.x = originalJupiterX;
                                baseGameJupiter.y = originalJupiterY;
                                baseGameJupiter.scale.set(JupiterOriginalScale.x,JupiterOriginalScale.y);

                                this._stateModel.changeSubgame('FreeGame');
                                this._stateModel.changeState('Idle');
                                this._layerManager.setVisibility('BaseGame', false);
                                this._layerManager.setVisibility('FreeGame', true);
                                this._layerManager.setVisibility('FreeGameJupiter', true);
                                this._eventManager.publish('onInitFreeGame');
                                this._componentManager.onOrientationChange(this._orientationModel.isLandscape, 'Reels');
                                this._componentManager.get('JupiterFreeGameLandscape').changeAnimation('idle', false, true);
                                this._componentManager.get('JupiterFreeGamePortrait').changeAnimation('idle', false, true);
                                this._componentManager.get('FreeGameSky').changeAnimation('clouds', false, true);
                                baseGameLayer.y = 0;
                                reels.y = 0;
                            },
                            () => {
                                this._layerManager.setVisibility('LightningFlash', false);
                                
                                
                                this._componentManager.get('FreeGameSky').changeAnimation('clouds', false, true);
                                this._componentManager.get('JupiterFreeGameLandscape').play();
                                this._componentManager.get('JupiterFreeGamePortrait').play();
                                this._componentManager.get('FreeGameSky').play();

                            });
                        });
                    });
                }
            });

            transitionTimeline.add(TweenMax.to(baseGameLayer, 1.5, {
                ease: Linear.easeNone,
                y: "+=2200"
            }));

            transitionTimeline.add(TweenMax.to(reels, 1.5, {
                ease: Linear.easeNone,
                y: "+=2200"
            }), "-=1.5");

            TweenMax.delayedCall(0.62, () => {
                this._componentManager.get('BaseGameSky').changeAnimation('transition_intro');
                transitionTimeline.play();

                // stop base game flames
                for (let i = 1; i < 3; i++) {
                    this._componentManager.get(`BaseGameFlame${i}`).hide();
                    this._componentManager.get(`BaseGameFlame${i}`).stop();
                }
            });
        }
    }
}